import ImageLayer from "../ImageLayer";
import { FabricImage } from "../../objects";
import { LayerCustomType, ObjectFitType } from "../../interfaces";
import { createImageObject, fitAbsoluteObject } from "../../utils";
import { ImageLoader } from "../../helpers";

const DefaultClipPathSrc = "/images/default_clip_path.png";
const DefaultPhotoSrc = "/images/default_photo.png";

export default class CustomImageLayer extends ImageLayer {
  protected static customType: LayerCustomType = LayerCustomType.CustomImage;
  protected static defaultImageSrc: string = DefaultPhotoSrc;
  protected static defaultTypeProps = {
    filter: { type: "", color: "" },
    strokeEffect: { type: "", color: "", width: 0 },
  };

  name: string = "Photo holder layer";
  protected clipPathObject: FabricImage = createImageObject({
    absolutePositioned: true,
  });

  constructor(options: any = {}) {
    const {
      transformSettings = {},
      typeSettings = {},
      ...layerProps
    } = options;
    super({ typeSettings });

    this.imageObject.set({
      ...CustomImageLayer.defaultTypeProps,
      ...typeSettings,
      clipPath: this.clipPathObject,
    });
    this.loadClipPath(typeSettings?.maskImageSrc);

    this.set(transformSettings);
    this.set(layerProps);

    this.on("moving", this.rerender.bind(this));
    this.on("rotating", this.rerender.bind(this));
    this.on("scaling", this.rerender.bind(this));
    this.on("removed", () => {
      this.imageObject.canvas?.remove(this.imageObject);
    });
  }

  protected rerender() {
    super.rerender();

    const flipX = this.flipX;
    const flipY = this.flipY;
    this.clipPathObject.set({ flipX, flipY });

    fitAbsoluteObject(this.clipPathObject, this, ObjectFitType.Fill);
    this.canvas?.requestRenderAll();
  }

  toObject() {
    const object = super.toObject();
    const imageProps = this.getImageProps();
    return { ...object, typeSettings: imageProps };
  }

  async loadClipPath(src?: Blob | string): Promise<string> {
    const srcToLoad =
      src instanceof Blob
        ? URL.createObjectURL(src)
        : src || DefaultClipPathSrc;
    try {
      const imageElement = await ImageLoader.load(srcToLoad);
      if (!imageElement) return "";
      this.clipPathObject.setElement(imageElement);
      this.imageObject.set({ maskImageSrc: srcToLoad });
      this.rerender();
      return srcToLoad;
    } catch (error) {
      console.error(error);
      return this.loadClipPath();
    }
  }
}
